/**
 * V70.195 — Efektif yetki bootstrap'ı (spec v1.3 §4.5).
 *
 * Oturum açıldıktan sonra motorun hesapladığı efektif yetki özeti bir kez çekilir ve
 * `can(resource, action)` / `hasField(resource, group)` olarak sunulur.
 *
 * ── BU BİR GÜVENLİK KATMANI DEĞİLDİR ─────────────────────────────────────
 * Spec §4.5: "Bu payload sadece UX optimizasyonudur. Backend tekrar kontrol eder."
 * §2.1: "Frontend'de buton veya sekme görünmemesi güvenlik olarak kabul edilmez."
 * Buradaki sonuç yalnız erken uyarı ve gereksiz 403 turunu önlemek içindir.
 *
 * ── YÜKLENİRKEN NE OLUR ──────────────────────────────────────────────────
 * `ready=false` iken `can()` **null** döner (true/false değil). Çağıran bunu
 * "bilinmiyor" diye okumalı ve mevcut davranışına düşmeli; `false` dönseydi ekranlar
 * bir an boş görünür, `true` dönseydi olmayan yetki varmış gibi gösterilirdi.
 */
import { useState, useEffect, useMemo, useCallback } from 'react';
import { hrAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { buildPermissionIndex } from '../config/hrPermissionDecode';

export default function useHrPermissions() {
  const { user } = useAuth();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!user) { setRows(null); return undefined; }
    hrAPI.getEffectivePermissions()
      .then((r) => { if (alive) setRows((r.data && r.data.permissions) || []); })
      .catch((e) => { if (alive) setError(e); });
    return () => { alive = false; };
  }, [user]);

  const index = useMemo(() => (rows ? buildPermissionIndex(rows) : null), [rows]);

  const can = useCallback(
    (resource, action) => (index ? index.can(resource, action) : null),
    [index],
  );
  const hasField = useCallback(
    (resource, group) => (index ? index.hasField(resource, group) : null),
    [index],
  );
  // V71 — menü/rota görünürlüğü için yalnız açık atamalar (rol/set/vekalet/istisna)
  const canExplicit = useCallback(
    (resource, action, wide) => (index ? index.canExplicit(resource, action, wide) : null),
    [index],
  );

  return { ready: !!index, loading: !index && !error, can, canExplicit, hasField, error, count: index ? index.size : 0 };
}
